import IntroductionView from './introduction_view';

const Introduction = IntroductionView;
export default Introduction;
